import { render, staticRenderFns } from "./InviteCandidatesButton.vue?vue&type=template&id=5d4b1662&"
import script from "./InviteCandidatesButton.vue?vue&type=script&lang=js&"
export * from "./InviteCandidatesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports